import { Directive, computed, input } from '@angular/core';

@Directive()
export abstract class PinShapeSvg {
  color = input<string>('white');
}
